<div class="routed-container">
    <div class="routed-content content-padding">
        <h2>Workplace Violence Prevention Program</h2>
        <p>We encourage all employees, managers, and safety officers to review both the document and the video to ensure a shared understanding of workplace safety expectations.</p>
        <hr>
        <br>
        <div class="tile-list">
            <!-- PDF Tile -->
            <div class="tile">
                <div class="tile-content">
                    <div class="icon">📄</div>
                    <div class="file-info">
                        <span class="file-name">Model WPV Plan General Industry.pdf</span>
                        <span class="file-type">PDF File</span>
                    </div>
                </div>
                <a class="action-btn" href="assets/files/Model-WPV-Plan-General-Industry.pdf" download>Download</a>
            </div>

            <!-- MP4 Tile -->
            <div class="tile">
                <div class="tile-content">
                    <div class="icon">🎥</div>
                    <div class="file-info">
                        <span class="file-name">Workplace Violence Prevention Video.mp4</span>
                        <span class="file-type">MP4 File</span>
                    </div>
                </div>
                <a class="action-btn" href="assets/files/wvpp-video-with-vo.mp4" target="_blank">View</a>
            </div>
        </div>

    </div>
</div>